import{a as i}from"./chunk-IA2FRWYU.js";import{j as e}from"./chunk-GEPA7FLG.js";e();var t=class{constructor(n){Object.assign(this,n)}static fromResponse(n){return new t({token:n.token?i.fromResponse(n.token):void 0,amount:n.amount!==void 0?n.amount:void 0})}};export{t as a};
//# sourceMappingURL=chunk-YSDIIVJV.js.map
